import { createSlice } from '@reduxjs/toolkit';

export interface SupplemeantryState {
  loadingOptions: boolean;
  loadingAuthUser: boolean;
  error: any | null;
  errorOptions: any | null;
  authorizedUserOptions: any;
  authorizedUser: any;
}

const initialState: SupplemeantryState = {
  loadingOptions: false,
  loadingAuthUser: false,
  error: null,
  errorOptions: null,
  authorizedUserOptions: null,
  authorizedUser: null,
};

const supplemeantrySlice = createSlice({
  name: 'supplemeantry',
  initialState,
  reducers: {
    authorizedUserOptionsRequest(state, action) {
      state.loadingOptions = true;
      state.errorOptions = null;
      state.error = null;
      state.authorizedUser = null;
    },
    authorizedUserOptionsFetched(state, action) {
      state.loadingOptions = false;
      state.authorizedUserOptions = action.payload;
      state.authorizedUser = null; //reset auth user when calling options
    },
    authorizedUserOptionsFetchFailed(state, action) {
      state.loadingOptions = false;
      state.errorOptions = action.payload;
    },
    updateAuthorizedUserRequest(state, action) {
      state.loadingAuthUser = true;
      state.errorOptions = null;
      state.error = null;
    },
    updateAuthorizedUserFetched(state, action) {
      state.loadingAuthUser = false;
      state.authorizedUser = action.payload;
    },
    updateAuthorizedUserFetchFailed(state, action) {
      state.loadingAuthUser = false;
      state.error = action.payload;
    },
    resetUpdateAuthorizedUser(state) {
      return initialState;
    },
  },
});

export const {
  authorizedUserOptionsRequest,
  authorizedUserOptionsFetched,
  authorizedUserOptionsFetchFailed,
  updateAuthorizedUserRequest,
  updateAuthorizedUserFetched,
  updateAuthorizedUserFetchFailed,
  resetUpdateAuthorizedUser,
} = supplemeantrySlice.actions;

export default supplemeantrySlice.reducer;
